const alertsStyle = Object.freeze({
  inputVariant: 'primaryOpaque',
});

export default alertsStyle;
